export { default as log } from "./_log";
export { default as merge } from "./_merge";
export { default as pluck } from "./_pluck";